import { GridBreakpointsArrayType, map } from './grid';

export type DisplayHelperType =
  | 'block'
  | 'inline-block'
  | 'inline'
  | 'inline-flex'
  | 'flex'
  | 'none'
  | 'table'
  | 'table-row'
  | 'table-cell';

export const displayHelperStyle = (
  display: DisplayHelperType | { [key in GridBreakpointsArrayType]?: DisplayHelperType },
) => map(display, d => (d ? `display: ${d} !important;` : ''));

export interface DisplayHelper {
  display?: DisplayHelperType | { [key in GridBreakpointsArrayType]?: DisplayHelperType };
}

export interface DisplayHelperStyledAttrProps extends DisplayHelper {
  $display?: DisplayHelperType | { [key in GridBreakpointsArrayType]?: DisplayHelperType };
}
